export default __webpack_public_path__ + "static/media/admin.1e2a7eb3.png";